import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  href
}: CTAButtonProps) {
  const buttonClasses = 'bg-green-600 hover:bg-green-700 text-white font-bold text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 w-full sm:w-auto min-h-[60px] sm:min-h-[70px] inline-block text-center';
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={buttonClasses} data-id="element-25">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={buttonClasses} data-id="element-26">
      {children}
    </button>;
}